// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_linkCard__fbwxH {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 24px;
  margin-bottom: 16px;
  text-align: left;
  font-size: 1.1em;
  color: #222;
  text-decoration: none;
  transition: box-shadow 0.2s, background 0.2s;
  display: block;
  font-weight: bold;
}
.Settings_linkCard__fbwxH:hover {
  box-shadow: 0 4px 16px rgba(25,118,210,0.15);
  background: #f5faff;
  color: #222;
}
.Settings_verticalButtonGroup__k75x- {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
.Settings_container__QzE-q {
  max-width: 500px;
  margin: 40px auto;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.Settings_form__ySVz2 {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}
.Settings_input__tk8e3 {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
.Settings_button__G90PA {
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.Settings_button__G90PA:hover {
  background: #1565c0;
}
.Settings_brandList__wIs3V {
  list-style: none;
  padding: 0;
  margin: 0;
}
.Settings_brandItem__mF5Fo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
.Settings_deleteButton__qxyH3 {
  background: #d32f2f;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s;
}
.Settings_deleteButton__qxyH3:hover {
  background: #b71c1c;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Settings/Settings.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,4CAA4C;EAC5C,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".linkCard {\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n  padding: 24px;\r\n  margin-bottom: 16px;\r\n  text-align: left;\r\n  font-size: 1.1em;\r\n  color: #222;\r\n  text-decoration: none;\r\n  transition: box-shadow 0.2s, background 0.2s;\r\n  display: block;\r\n  font-weight: bold;\r\n}\r\n.linkCard:hover {\r\n  box-shadow: 0 4px 16px rgba(25,118,210,0.15);\r\n  background: #f5faff;\r\n  color: #222;\r\n}\r\n.verticalButtonGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-bottom: 32px;\r\n}\r\n.container {\r\n  max-width: 500px;\r\n  margin: 40px auto;\r\n  padding: 24px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n}\r\n.form {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n}\r\n.input {\r\n  flex: 1;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n}\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:hover {\r\n  background: #1565c0;\r\n}\r\n.brandList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.brandItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n.deleteButton {\r\n  background: #d32f2f;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 4px 10px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.deleteButton:hover {\r\n  background: #b71c1c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkCard": `Settings_linkCard__fbwxH`,
	"verticalButtonGroup": `Settings_verticalButtonGroup__k75x-`,
	"container": `Settings_container__QzE-q`,
	"form": `Settings_form__ySVz2`,
	"input": `Settings_input__tk8e3`,
	"button": `Settings_button__G90PA`,
	"brandList": `Settings_brandList__wIs3V`,
	"brandItem": `Settings_brandItem__mF5Fo`,
	"deleteButton": `Settings_deleteButton__qxyH3`
};
export default ___CSS_LOADER_EXPORT___;
